export const LogStoreAction = {
  FILTER_LOGS: "FILTER_LOGS",
  SET_MAX_MSG_COUNT: "SET_MAX_MSG_COUNT",
  ADD_LOG: "ADD_LOG",
  ROLLUP_LOG: "ROLLUP_LOG",
  CLEAR_LOGS: "CLEAR_LOGS",
  CLEAR_FILTERING: "CLEAR_FILTERING"
};


// WEBPACK FOOTER //
// ./src/components/store/action/LogStoreAction.js